let aliveControllerRef = null;

export const setAliveController = (controller) => {
  if (!controller) {
    console.warn("Invalid controller passed");
    return;
  }
  aliveControllerRef = controller;
};

export const dropCacheById = (id) => {
  if (!aliveControllerRef) {
    console.warn("AliveController not initialized");
    return;
  }

  try {
    if (id) {
      console.log(id,"iddddddddddddddghjsjhhbbhh")
      aliveControllerRef.dropScope?.(id);
      aliveControllerRef.drop?.(id);
    } else {
      aliveControllerRef.clear?.();
    }
  } catch (error) {
    console.error("Error while dropping cache:", error);
  }
};